import Notifications from './Notifications';

export default Notifications;


// WEBPACK FOOTER //
// ./src/modules/notifications/index.js